export const initialUiState = {
  showFaq: false,
  selectedTab: null,
  showTutorial: false,
  showControlMenu: true,
  showDataStepperModal: true,
};